<template>
  <div v-if="slider.length < 1">
    <LoadingWidget v-if="loading" class="py-0 py-md-13 py-lg-16" />

    <transition name="fade">
      <video
        v-if="!loading && video"
        class="d-block video-featured"
        :src="files + video"
        autoplay
        loop
        muted
      ></video>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";

const _config = {
  mod: "about",
};

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    slider() {
      return this.$rest("slider").list;
    },
    video() {
      const item = this.$rest(_config.mod).item;

      return this.$vuetify.breakpoint.xsOnly
        ? item.video_mobile
        : item.video_desktop;
    },
  },
  components: {
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
.video-featured {
  aspect-ratio: 1920 / 680;
  object-fit: cover;
  -o-object-fit: cover;
  width: 100%;

  @media screen and (max-width: 600px) {
    aspect-ratio: 600 / 600;
  }
}
</style>
